import React from 'react'

const Footer = () => {
  return (
    <footer className='mt-[194.54px]'>
        <p>Watch The Video</p>
    </footer>
  )
}

export default Footer;